import { encryptAesGcm } from "./crypto_aes";
import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE, SECRET_KEY } from "../config/vars";

export async function fetchOperator() {
    const res = await apiFetch(`${API_BASE}/operators/operator`);
    if (!res.ok) throw new Error("Не вдалося завантажити дані оператора");
    return res.json();
}

export async function updateOperator(data) {
    const payload = { ...data };

    if ((payload.current_password || payload.new_password) && !SECRET_KEY) {
        throw new Error("Не налаштований ключ шифрування (REACT_APP_SECRET_KEY)");
    }

    if (payload.current_password) {
        payload.current_password = await encryptAesGcm(SECRET_KEY, payload.current_password);
    }
    if (payload.new_password) {
        payload.new_password = await encryptAesGcm(SECRET_KEY, payload.new_password);
    }

    const res = await apiFetch(`${API_BASE}/operators/operator`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("Не вдалося оновити профіль");
    return res.json();
}
